import { Button, Tooltip } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";
import { useAuthUser } from "../../hooks/useAuthUser";
import { RpiNotification, useRpiNotifications } from "../../hooks/useRpiNotifications";

/** Encapsulates Pay Now visibility rules and drawer open/close state. */
export function usePayNowState() {
  const user = useAuthUser();
  const { notifications } = useRpiNotifications();
  const [payNowOpen, setPayNowOpen] = React.useState(false);

  const hasNoPaymentMethod = !user.isSandbox && notifications[RpiNotification.PAYMENT_METHOD];
  const showPayNow = (user.is.CUSTOMER_ADMIN || user.is.USER) && !user.isSandbox;

  return {
    showPayNow,
    hasNoPaymentMethod,
    payNowOpen,
    openPayNow: () => setPayNowOpen(true),
    closePayNow: () => setPayNowOpen(false),
  };
}

interface PayNowButtonProps {
  hasNoPaymentMethod: boolean | undefined;
  onClick: () => void;
}

export const PayNowButton: React.FC<PayNowButtonProps> = ({ hasNoPaymentMethod, onClick }) => {
  const button = (
    <Button
      variant="filled"
      intent="primary"
      size="large"
      disabled={!!hasNoPaymentMethod}
      onClick={hasNoPaymentMethod ? undefined : onClick}
      aria-label="Pay Now"
      data-testid="pay-now-button"
    >
      <IconV3 icon="credit_card" color="inherit" />
      Pay Now
    </Button>
  );

  if (hasNoPaymentMethod) {
    return (
      <Tooltip content="Add a payment method before paying for orders" side="bottom">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
